import React, {useEffect} from 'react'
import {useNavbar} from "../states/common/client";
import {List, ListItemButton} from "@mui/material";
import {DISABLED_COLOR} from "../constants/constants";
import {useLogout} from "../states/user/hooks";
import {useNavigate} from "react-router-dom";

export const SettingsPage = () => {
    const { setNavbarTitle, reset } = useNavbar()
    const navigate = useNavigate()
    // TODO 확인 모달
    const { logout } = useLogout()

    useEffect(() => {
        reset()
        setNavbarTitle("설정")
    }, []);

    return (
        <div className={"fullscreen"}>
            <List>
                <ListItemButton onClick={() => { navigate('/settings/notification') }} sx={{paddingY: '20px'}}>알림 설정</ListItemButton>
                {/*<ListItemButton onClick={() => { navigate('/send-feedback') }} sx={{paddingY: '20px'}}>의견 보내기</ListItemButton> TODO 활성화 */}
                <ListItemButton onClick={() => { navigate('/policy/terms-of-service') }} sx={{paddingY: '20px'}}>이용약관</ListItemButton>
                <ListItemButton onClick={() => { navigate('/policy/privacy')}} sx={{paddingY: '20px'}}>개인정보 처리방침</ListItemButton>
                <ListItemButton onClick={ logout } sx={{paddingY: '20px'}}>로그아웃</ListItemButton>
                <ListItemButton onClick={() => {}} sx={{paddingY: '20px', color: DISABLED_COLOR, fontWeight: 300}}>회원 탈퇴</ListItemButton>
            </List>
        </div>
    )
}